export const Logo = ({ className = "h-12" }) => (
    <img
        src="/assets/logo-navbar.png"
        alt="FnB International"
        className={`${className} w-auto object-contain`}
        data-testid="logo-image"
    />
);
